const tempConverter = kelvin => Math.round(kelvin - 273.15);

export default tempConverter;